export default __webpack_public_path__ + "static/media/video_placeholder_mobile.80ebb495.png";